import { displayMonthYear } from 'helpers/date';

const ReadOnlyMonthYear = ({ month, year }) => {
  return <small className="d-block">{displayMonthYear(month, year)}</small>;
};

export default ReadOnlyMonthYear;
